import { render } from "./VouchersOfSale.vue?vue&type=template&id=3cd1f6a9"
import script from "./VouchersOfSale.vue?vue&type=script&lang=js"
export * from "./VouchersOfSale.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__